/* eslint no-unused-vars: "warn" */
function markty(str, reg, rules, unlimited) {
  if ( unlimited === void 0 ) { unlimited = false; }

  var prev, match, chunk, last = 0, out = '';
  var tokenizer = reg;
  while ( (match = tokenizer.exec(str)) ) {
    prev = str.substring(last, match.index);
    last = tokenizer.lastIndex;

    if (rules && typeof(rules) === "function") {
      chunk = rules(str, match);
    } else {
      chunk = rules;
    }

    out += prev;
    out += chunk;
  }
  out += str.substring(last);

  if( tokenizer.test(out) && unlimited === true ) {
    return markty(out, new RegExp(tokenizer), rules, true);
  } else {
    return out;
  }
}

/*eslint no-unused-vars: 1*/
function marktytoml (TOML) {
    var tomlBlocks = '^\\s*\\[(\\[)?(.*?)\\]\\]?(?= *$)((?:[\\w\\W](?!^\\s*\\[))*)';
    var matchThis = new RegExp(("" + tomlBlocks), 'gm');
    var json = {};
    TOML = TOML[0] === "[" ? TOML : "[]\n"+TOML;

    markty(TOML, matchThis, function (string, match) {
        var token = match[0];
        var header_array = match[1];
        var header_path = match[2];
        var body = match[3];

        if (header_array){  // header is like [[grand.parent]]
            // @TODO: Should implement array blocks
            setWithPath(json, header_path.trim(), parseBody(body), true);
        }
        else if (header_path === ""){ // header is like []
            json = Object.assign({}, json, parseBody(body));
        }
        else {  // header is like [grand.parent]
            setWithPath(json, header_path.trim(), parseBody(body), false);
        }

    });

    return  JSON.parse(JSON.stringify(json, replacer), reviver)
}

function parseBody (TOML) {

    var matchThis = new RegExp("^[ \t]*(.+?) *[=:] *(?:\"((?!\")[\\w\\W]+?)\"|(\\[[\\w\\W]+?(?:(?: *])+ *$\\n*)+)|(\\{[\\w\\W]+?(?:(?: *})+ *$\\n*)+)|(.+) *)|^(.+)$", 'gm');

    var json = {};

    markty(TOML, matchThis, function (string, match) {
        var token = match[0];
        var key = match[1];
        var val_quotes = match[2];
        var val_array = match[3];
        var val_json = match[4];
        var val_noquotes = match[5];
        var trash = match[6];
        var k, v;

        if (key){
            if (key.charAt(0) === "#") {return}
            k = key.charAt(0) === "\"" && key.charAt(key.length-1) === "\"" ? key.slice(1, -1) : key;
            if (val_quotes) {v = val_quotes;}
            if (val_array || val_json) {
                v = JSON.parse(("" + (val_array || val_json)));
            }
            // val_noquotes is important: it is a value NOT surrounded by double-quotes
            if (val_noquotes) {
                val_noquotes = val_noquotes.trim();
                if (+val_noquotes === +val_noquotes){ v = Number(val_noquotes);}
                else if (val_noquotes === 'true'){ v = true; }
                else if (val_noquotes === 'false'){ v = false; }
                else if (val_noquotes === 'inf' || val_noquotes === '+inf'){ v = Infinity; }
                else if (val_noquotes === '-inf'){ v = -Infinity; }
                else if (parseInt(val_noquotes, 16).toString(16) === val_noquotes.toLowerCase() ){ v = parseInt(val_noquotes, 16); }
                else if (parseInt(val_noquotes, 8).toString(8) === val_noquotes.toLowerCase() ){ v = parseInt(val_noquotes, 8); }
                else if (parseInt(val_noquotes, 2).toString(2) === val_noquotes.toLowerCase() ){ v = parseInt(val_noquotes, 2); }
                // else if (dateRegex) {
                //     /(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?([Z+-])?(?:(\d{1,2}):(\d{2}))?/
                // }
                else { v = val_noquotes; }
            }
            json[k] = v;
            return ''
        }
        // If a user puts a value on multiple lines (using line-breaks), WITHOUT using double-quotes
        // everything coming after the line-break is trash
        else if (trash) { return '' }
    });

    return json
}

function sanitizeSpaces(str) {
    str = str.trim();
    str = (str.substr(0,1) === '"' && str.substr(-1) === '"') ? str.slice(1,-1) : str;
    return str
}

function setWithPath(obj, keys, val, asArray) {
	asArray = asArray ? true : false;
    keys.split && (keys=keys.split('.'));
	var i=0, l=keys.length, t=obj, x;
	for (; i < l; ++i) {
        keys[i] = sanitizeSpaces(keys[i]);
        if (t instanceof Array){x = t[t.length-1]; i--;} else { x = t[keys[i]]; }

        if (i === l-1) {
            x instanceof Array ? t[keys[i]].push(val) : (t[keys[i]]=asArray?[val]:val);
        }
        else {
            x instanceof Array ? ( t = x ) : (t = t[keys[i]] = (x == null ? {} : x));
        }

	}
}


var replacer = function(k,v){    
    if (v !== v) { return '___$$$NaN$$$___' }
    if (v === Infinity) { return '___$$$Infinity$$$___' }
    if (v === -Infinity) { return '___$$$-Infinity$$$___' }
    return v
};

var reviver = function(k,v){
    if (v === '___$$$NaN$$$___') { return NaN }
    if (v === '___$$$Infinity$$$___') { return Infinity }
    if (v === '___$$$-Infinity$$$___') { return -Infinity }
    return v
};

export default marktytoml;
//# sourceMappingURL=marktytoml.es.js.map
